import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent {

  @Input() title: string = '';
  // @Input() footerType: 'oneButton' | 'twoButtons' = 'twoButtons';
  @Input() disabledButton: boolean = false;
  @Input() showSaveButton: boolean = true;
  @Input() showEditButton: boolean = false;
  @Input() showCloseButton: boolean = true;
  @Input() size: 'small' | 'medium' | 'big' | 'medium-diagnosis' | 'none' |'full'| 'auto' = 'big';
  @Input() closeBtnText = 'Cancelar';
  @Input() saveBtnText = 'Salvar';
  @Input() editBtnText = 'Atualizar';
  @Input() footerText = ''

  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() edit = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<PopUpComponent>) {
    this.dialogRef.disableClose = true;
  }

  _close() {
    this.close.emit();
  }

  _save() {
    this.save.emit();
  }

  _edit() {
    this.edit.emit();
  }
}
